import { vservice } from '@niknevis/vue-modules'
import { AdminDepartmentRoute } from '@/modules/department/routes/admin-department.route'
import { DepartmentRequestModel } from '@/modules/department/models/department-request.model'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'

@vservice()
export class AdminDepartmentService {
  constructor(
    private readonly routes: AdminDepartmentRoute
  ) {
  }

  storeDepartment(data: DepartmentRequestModel) {
    return Inertia.post(
      this.routes.store(),
      data
    )
  }

  updateDepartment(departmentId: number, data: DepartmentRequestModel) {
    return Inertia.put(
      this.routes.update(departmentId),
      data
    )
  }
}
